import TagLine from './TagLine';
import Service from './Service';
import NewsFeed from '../post/NewsFeed';

export default function Home() {
    return (
        <div>
            <main id="main">
                <TagLine /> 
                <Service />
                <NewsFeed />
            </main>
        </div>

    );
}